<div class="facility-details-add-container"
     [formGroup]="agentForm"
     fxLayout="column"
     fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()"
            [class.spinner]="processingRequest"
            [disabled]="processingRequest || agentForm.invalid"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Doradcy Placówki</h3>

        <table mat-table [dataSource]="ofwcasDataSource">

          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>Imię i nazwisko</th>
            <td mat-cell *matCellDef="let element">
              {{ element.firstName }} {{ element.lastName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button [ngClass]="element.status?.color + '-button'">
                {{ element.status?.name }}
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="portalDa">
            <th mat-header-cell *matHeaderCellDef>Widoczny na portalu DA</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-slide-toggle
                [formControl]="getOfwcaPermissionControl(i, 'visibleOnDobryAgent')"
                (change)="onVisibleOnDobryAgentChange(i)"
              >
                {{
                  getOfwcaPermissionControl(i, 'visibleOnDobryAgent').value
                    ? 'TAK'
                    : 'NIE'
                }}
              </mat-slide-toggle>

              <!--              <div class="permission-source" *ngIf="getDobryAgentCoordinator(element) as coordinator">-->
              <!--                Agent DA: {{ coordinator.firstName }} {{ coordinator.lastName }}-->
              <!--                <span *ngIf="!coordinator.active">(nieaktywny)</span>-->
              <!--              </div>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Numer telefonu</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-form-field class="table-form-field">
                <mat-label>
                  Telefon
                </mat-label>
                <input
                  matInput
                  appCapitalizeFirst
                  placeholder="Nr telefonu"
                  prefix="+48" mask=" 000 000 000"
                  [formControl]="getOfwcaPermissionControl(i, 'phone')"
                >
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'phone').hasError('required')">
                  Numer telefonu jest wymagany
                </mat-error>
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'phone').hasError('pattern')">
                  Podaj poprawny numer telefonu
                </mat-error>
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'phone').hasError('backendError')">
                  {{ getOfwcaPermissionControl(i, 'phone').getError('backendError') }}
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-form-field class="table-form-field">
                <mat-label>
                  Email
                </mat-label>
                <input
                  matInput
                  [formControl]="getOfwcaPermissionControl(i, 'email')">
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'email').hasError('required')">
                  Email jest wymagany
                </mat-error>
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'email').hasError('email')">
                  Podaj poprawny adres email
                </mat-error>
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'email').hasError('backendError')">
                  {{ getOfwcaPermissionControl(i, 'email').getError('backendError') }}
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>


          <ng-container matColumnDef="blog">
            <th mat-header-cell *matHeaderCellDef>Uprawnienia - blog</th>
            <td mat-cell *matCellDef="let element; let i = index">

              <ng-container *ngIf="hasUser360Account(element); else noUser360Blog">
                <mat-slide-toggle
                  [formControl]="getOfwcaPermissionControl(i, 'blogAccess')"
                  (change)="onVisibleOnDobryAgentChange(i)"
                >
                  {{
                    getOfwcaPermissionControl(i, 'blogAccess').value
                      ? 'TAK'
                      : 'NIE'
                  }}
                </mat-slide-toggle>
              </ng-container>

              <ng-template #noUser360Blog>
                Brak konta ASF360
              </ng-template>

            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef>Uprawnienia - edycja wizytówki</th>
            <td mat-cell *matCellDef="let element; let i = index">

              <ng-container *ngIf="hasUser360Account(element); else noUser360Edit">
                <mat-slide-toggle
                  [formControl]="getOfwcaPermissionControl(i, 'businessCardEditAccess')"
                  (change)="onVisibleOnDobryAgentChange(i)"
                >
                  {{
                    getOfwcaPermissionControl(i, 'businessCardEditAccess').value
                      ? 'TAK'
                      : 'NIE'
                  }}
                </mat-slide-toggle>
              </ng-container>

              <ng-template #noUser360Edit>
                Brak konta ASF360
              </ng-template>

            </td>
          </ng-container>

          <ng-container matColumnDef="avatar">
            <th mat-header-cell *matHeaderCellDef>Avatar</th>

            <td mat-cell *matCellDef="let element; let i = index">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="agent-avatar">
                  <img
                    *ngIf="getAgentAvatarUrl(element); else noAgentAvatar"
                    [src]="getAgentAvatarUrl(element)"
                    alt="Avatar doradcy">

                  <ng-template #noAgentAvatar>
                    <mat-icon>person</mat-icon>
                  </ng-template>
                </div>

                <input
                  #agentImageInput
                  type="file"
                  hidden
                  accept="image/jpeg,image/png,image/webp"
                  (change)="onAgentImageSelected($any($event.target).files, element, i); agentImageInput.value = ''">

                <button
                  mat-stroked-button color="primary" type="button"
                  matTooltip="JPG, PNG lub WEBP, maksymalnie 3 MB"
                  [disabled]="!getOfwcaPermissionControl(i, 'visibleOnDobryAgent').value || isAgentImageUploading(element)"
                  (click)="agentImageInput.click()">

                  <mat-icon *ngIf="!isAgentImageUploading(element)">upload</mat-icon>
                  <mat-icon *ngIf="isAgentImageUploading(element)">hourglass_empty</mat-icon>

                  <span>  {{ getAgentAvatarUrl(element) ? 'Zmień' : 'Dodaj' }}    </span>
                </button>

                <button
                  *ngIf="getAgentAvatarUrl(element)"
                  mat-icon-button
                  color="warn"
                  type="button"
                  matTooltip="Usuń avatar"
                  [disabled]="isAgentImageUploading(element)"
                  (click)="deleteAgentImage(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <app-loading [loading]="loading" [description]="'Pobieranie listy ...'"></app-loading>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button
      (click)="save()"
      [class.spinner]="processingRequest"
      [disabled]="processingRequest || agentForm.invalid"
      mat-stroked-button
      color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
